import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import Pagination from "../Pagination";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isEmpty, startCase } from "lodash";
import { BsArrowUpShort } from "react-icons/bs";

function NavBarNotification() {
  const { t } = useTranslation();
  const { logoutUser, updatePageName, user } = useContext(AuthContext);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [notifications, setAllNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [isDelete, setIsDelete] = useState(false);
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });

  const getAllNotifications = async (data) => {
    try {
      const payload = {
        page,
        pageSize,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };

      const path = apiPath.getNotificationListAdmin;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setAllNotifications(response?.docs);
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.log("error ", error);
      setPaginationObj({});
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };


  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  useEffect(() => {
    updatePageName(t('O_NOTIFICATIONS'))
    getAllNotifications();
  }, [ page, sort]);

  return (
    <div>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <div className="p-3">
              <div className="overflow-x-auto relative rounded-lg border">
                <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                  <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="py-3 px-2">
                        #
                      </th>
                      <th scope="col" className="py-3 px-2">
                        {t("O_TITLE")}
                      </th>
                      <th scope="col" className="py-3 px-2">
                        {/* {t('O_TITLE')} */}
                        {t("O_MESSAGE")}
                      </th>

                      <th
                        scope="col"
                        className="py-3 px-2 cursor-pointer"
                        onClick={() => {
                          if (
                            sort.sortKey === "createdAt" &&
                            sort.sortType === "asc"
                          ) {
                            setSort({
                              sortKey: "createdAt",
                              sortType: "desc",
                            });
                          } else {
                            setSort({
                              sortKey: "createdAt",
                              sortType: "asc",
                            });
                          }
                        }}
                      >
                        <div className="flex justify-center">
                          <span>{t("O_CREATED_AT")}</span>
                          <span>
                            {sort.sortKey === "createdAt" &&
                              sort.sortType === "asc" && (
                                <BsArrowUpShort className="w-4 h-4" />
                              )}
                            {sort.sortKey === "createdAt" &&
                              sort.sortType === "desc" && (
                                <BsArrowUpShort className="w-4 h-4 rotate-180" />
                              )}
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {notifications &&
                      notifications?.map((item, i) => (
                        <tr
                          key={i}
                          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                        >
                          <th
                            scope="row"
                            className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                          >
                            {i + 1 + 10 * (page - 1)}
                          </th>
                          <td className="py-2 px-2 border-r">
                            {startCase(item?.title) || t("O_N/A")}
                          </td>
                          <td className="py-2 px-2 border-r">
                            {item?.message}
                          </td>
                          <td className="py-2 px-2 border-r text-center">
                            {dayjs(item?.createdAt).format(
                              "DD-MM-YYYY hh:mm A"
                            )}
                          </td>
                        </tr>
                      ))}
                    {isEmpty(notifications) ? (
                      <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                        <td className="py-2 px-2 border-r" colSpan={8}>
                          {t("O_NO_RECORD_FOUND")}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
      <>
        {/* {editShowModal ? (
          <UserEdit
            setEditShowModal={setEditShowModal}
            getAllNotifications={getAllNotifications}
            item={item}
          />
        ) : null} */}
        {/* {viewShowModal ? (
          <UserView
            setViewShowModal={setViewShowModal}
            getAllNotifications={getAllNotifications}
            item={item}
          />
        ) : null} */}
      </>
    </div>
  );
}
export default NavBarNotification;
